import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
    createTeamMember,
    deleteTeamMember,
    resetPassword,
    updateTeamMember,
    type InviteTeamMemberBody,
    type TeamResetPasswordBody,
} from "@/api/team";
import { toast } from "sonner";



export const useInviteTeamMember = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload: InviteTeamMemberBody) => createTeamMember(payload),
        onSuccess: () => {
            toast.success('Team member invited successfully');
            queryClient.invalidateQueries({ queryKey: ['team'] });
            queryClient.invalidateQueries({ queryKey: ['team-infinite'] });
        },
        onError: (error) => {
            toast.error('Failed to invite team member');
            console.error(error);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['team'] });
            queryClient.invalidateQueries({ queryKey: ['team-infinite'] });
        },
    });
}



export const useResetPassword = () => {
    return useMutation({
        mutationFn: (payload: TeamResetPasswordBody) => resetPassword(payload),
        onSuccess: () => {
            toast.success("Password reset successfully");
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : "Failed to reset password";
            toast.error(message);
            console.error(error);
        },
    });
};


export const useUpdateTeamMember = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }: { id: string, payload: any }) => updateTeamMember(id, payload),
        onSuccess: () => {
            toast.success('Team member updated successfully');
        },
        onError: (error) => {
            toast.error('Failed to update team member');
            console.error(error);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ['team'] });
            queryClient.invalidateQueries({ queryKey: ['team-infinite'] });
            queryClient.invalidateQueries({ queryKey: ['auth', 'me'] });
        },
    });
}

export const useDeleteTeamMember = () => {
    return useMutation({
        mutationFn: (id: string) => deleteTeamMember(id),
        onSuccess: () => {
            toast.success('Team member deleted successfully');
        },
        onError: (error) => {
            toast.error('Failed to delete team member');
            console.error(error);
        },
    });
}